/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Dispatch, SetStateAction, useState } from "react";
import { Box, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import TableComponent from "../../components/TableComponent";
import AddCategory from "../../Modals/addCategory";
import IosSwitchMain from "../../components/iosSwitchMain";
import { GridColDef } from "@mui/x-data-grid";
import { Categories } from "../../types/General";
import { showError, showToast } from "../../constants/toasts";
import {
  useChangeCategoryStatusMutation,
  useChangeInternalProcessStatusMutation,
  useLazyDeleteCategoryQuery,
  useLazyDeleteInternalProcessQuery,
} from "../../service/category";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import AddInternalProcess from "../../Modals/addInternalProcess";

const InternalProcessList = ({
  activeTab,
  data,
  page,
  selectedCategory,
  setSelectedCategory,
  selectedId,
  setSelectedId,
  getInternalProcessApi,
}: {
  activeTab: number;
  data?: Categories[];
  page?: number;
  selectedId: string;
  setSelectedId: Dispatch<SetStateAction<string>>;
  selectedCategory?: Categories | null;
  setSelectedCategory: Dispatch<SetStateAction<Categories | null>>;
  getInternalProcessApi: () => void;
}) => {
  const [deleteProcess] = useLazyDeleteInternalProcessQuery();
  const [changeInternalProcessStatus] =
    useChangeInternalProcessStatusMutation();
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const handleCloseModal = () => setOpen(false);

  const deleteCategoryApi = async () => {
    try {
      const response = await deleteProcess({ id: selectedId }).unwrap();
      if (response.status === 200) {
        getInternalProcessApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const changeCategoryStatusApi = async (id: string) => {
    try {
      const response = await changeInternalProcessStatus({ id }).unwrap();
      if (response.status === 200) {
        getInternalProcessApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const columns: GridColDef[] = [
    {
      flex: 1,
      minWidth: 50,
      field: "id",
      headerName: "S.No",
      editable: false,
      sortable: false,
      renderCell: (params) => {
        const allRowIds = params.api.getAllRowIds();
        const index = allRowIds.indexOf(params.id);
        return (
          <div className="user_block">
            <p>{index + 1}</p>
          </div>
        );
      },
    },

    {
      flex: 2,
      minWidth: 150,
      field: "name",
      headerName: "Category Name",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.name}</p>
          </div>
        );
      },
    },

    {
      flex: 1,
      minWidth: 100,
      field: "show",
      headerName: "Show",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => (
        <IosSwitchMain
          checked={row?.isActive}
          onChange={() => changeCategoryStatusApi(row?.id)}
        />
      ),
    },
    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => (
        <div className="table_actions v2">
          <Box>
            <IconButton
              onClick={() => {
                setSelectedId(row?.id);
                setSelectedCategory(row);
                setOpen(true);
              }}
            >
              <img src="/static/images/edit_icon.svg" alt="Edit" />
            </IconButton>
          </Box>
          {row?.isDeletable ? (
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedId(row?.id);
                  setOpenDelete(true);
                }}
              >
                <img src="/static/images/trash2_icon.svg" alt="Delete" />
              </IconButton>
            </Box>
          ) : null}
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="sorting_table">
        <TableComponent columns={columns} rows={data} />
      </div>

      <AddInternalProcess
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        selectedCategory={selectedCategory}
        selectedId={selectedId}
        getProcessApi={getInternalProcessApi}
      />

      <ConfirmationModal
        text={"Are you sure to delete this Category?"}
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={deleteCategoryApi}
      />
    </>
  );
};

export default InternalProcessList;
